import React from 'react';
import './Intro.css';
import logo from 'url:../../assets-optimized/redesign/logo.png';
import Person from 'url:../../assets/redesign/slider/person.svg';

const Intro = ({ children, className = '', style = {} }) => {
  return (
    <section className={`redesign-intro ${className}`} style={style}>
      <h2>
        {children || (
          <>
            We are Marriott Media: a travel ad platform that tethers brands to real human
            moments—where intent is high, attention is undivided, and decisions are made in motion.
            We bridge the distance
            <span className='audience-pill'>
              <img src={Person} alt='Person Icon' className='audience-icon' />
              between your brand and travelers.
            </span>
          </>
        )}
      </h2>
    </section>
  );
};

export default Intro;
